module.exports = __webpack_public_path__ + "img/no-history.14000434.svg";